import Form from "react-bootstrap/Form";
import { Container, InputGroup, Col, Row } from "react-bootstrap";
import { NumericFormat, PatternFormat } from "react-number-format";
import "./FormProperty.css";
import React, { useState, useEffect } from "react";
import useStore from "../../../Zustand/Zustand";
import { InformationCircleIcon } from "@heroicons/react/24/outline";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ZustandFormImovel from "../../../Zustand/ZustandFormImovel";
import ZustandValidationProponente from "../../../Zustand/ZustandFormProponent";
import ZustandValidationConjugue from "../../../Zustand/ZustandValidationConjugue";
import ZustandSelectBankType from "../../../Zustand/ZustandSelectBankType";
import ZustandProductCgi from "../../../Zustand/ZustandProductCgi";
import formatToReal from "../../../Utils/fomartToReal";
import convertToFloat from "../../../Utils/convertToFloat";

const FormProperty = () => {
  const Link = ({ id, children, title }) => (
    <OverlayTrigger overlay={<Tooltip id={id}>{title}</Tooltip>}>
      <a href="#/">{children}</a>
    </OverlayTrigger>
  );

  const { rendaMensalClient, rendaMensalProponent4, idadeCliente } = useStore();

  const { rendaProponente } = ZustandValidationProponente();
  const { rendaConjugue } = ZustandValidationConjugue();
  const {
    cgi,
    setValorEmprestimo,
    valorEmprestimo,
    prazoMesesCgiIsErro,
    prazoMesesCgi,
    valorEmprestimoIsErro,
    setPrazoMesesCgi,
    valorImovelCgi,
    setValorImovelCgi,
    valorDoImovelCgiIsErro,
    setValorDoImovelCgiIsErro,
    setValorEmprestimoIsErro,
    setPrazoMesesCgiIsErro,
    setImovelCgiIsErro,
  } = ZustandProductCgi();

  const {
    tipoImovel,
    situacaoImovel,
    valorDoImovel,
    valorFGTS,
    valorDeEntrada,
    prazoMeses,
    setTipoImovel,
    setSituacaoImovel,
    setValorDoImovel,
    setValorFGTS,
    setValorDeEntrada,
    setPrazoMeses,
    valorDoImovelIsErro,
    valorEntradaIsErro,
    setValorEntradaIsErro,
    prazoMesesIsErro,
    setValorDoImovelIsErro,
    setPrazoMesesIsErro,
  } = ZustandFormImovel();

  const { selectInter } = ZustandSelectBankType();

  const ValidateForm = () => {
    const { valorDoImovel, valorDeEntrada, setImovelErro } =
      ZustandFormImovel.getState();

    let valorDoImovelValido = valorDoImovel >= 100000.0;
    if (selectInter == "Multibancos") {
      valorDoImovelValido = valorDoImovel >= 100000.0;
    } else {
      valorDoImovelValido = valorDoImovel >= 200000.0;
    }

    let valorEntradaValido;
    if (selectInter == "Multibancos") {
      valorEntradaValido = valorDeEntrada + valorFGTS >= valorDoImovel * 0.2;
    } else {
      valorEntradaValido = valorDeEntrada + valorFGTS >= valorDoImovel * 0.25;
    }
    const prazoValido = !validadorPrazoPorMesesFinInter();

    const isFormValid =
      valorDoImovelValido &&
      prazoValido &&
      valorEntradaValido &&
      valorEmprestimo &&
      setImovelErro(!isFormValid);
  };

  const ValidateFormCgi = () => {
    const valorDoImovelValido = valorImovelCgi >= 200000.0;
    const prazoValido = !validadorPrazoPorMesesCgiIsErro();
    const valorEmprestimoValido =
      (valorEmprestimo ?? 0) <= (valorImovelCgi ?? 0) * 0.58 &&
      (valorEmprestimo ?? 0) >= 70000;

    let isFormValidCgi =
      valorDoImovelValido && prazoValido && valorEmprestimoValido;

    setImovelCgiIsErro(!isFormValidCgi);
  };

  useEffect(() => {
    ValidateFormCgi();
  }, [valorImovelCgi, prazoMesesCgi, prazoMesesCgiIsErro, valorEmprestimo]);

  useEffect(() => {
    ValidateForm();
  }, [valorDoImovel, prazoMeses, prazoMesesIsErro]);

  useEffect(() => {
    if (valorDoImovel > 1) {
      setValorDoImovelIsErro(false);
    }
  }, [valorDoImovel]);

  useEffect(() => {
    if (valorDeEntrada > 1) {
      setValorEntradaIsErro(false);
    }
  }, [valorDeEntrada]);

  useEffect(() => {
    if (prazoMeses > 1) {
      setPrazoMesesIsErro(false);
    }
  }, [prazoMeses]);

  useEffect(() => {
    if (valorImovelCgi > 1) {
      setValorDoImovelCgiIsErro(false);
    }
  }, [valorImovelCgi]);

  useEffect(() => {
    if (prazoMesesCgi > 1) {
      setPrazoMesesCgiIsErro(false);
    }
  }, [prazoMesesCgi]);

  useEffect(() => {
    if (valorEmprestimo > 1) {
      setValorEmprestimoIsErro(false);
    }
  }, [valorEmprestimo]);
  const convertRendaCongue = convertToFloat(rendaConjugue)
  const convertRendaProponente3 = convertToFloat(rendaProponente)
  const convertRendaProponent4 = convertToFloat(rendaMensalProponent4)
  const converRendaMensalClient = convertToFloat(rendaMensalClient)


  const rendaTotal =
    converRendaMensalClient + convertRendaCongue + convertRendaProponente3 + convertRendaProponent4;

  function calcularIdade(dataNascimento) {
    if (dataNascimento.length !== 8 || isNaN(dataNascimento)) {
      return "Data inválida";
    }

    const dia = parseInt(dataNascimento.substring(0, 2), 10);
    const mes = parseInt(dataNascimento.substring(2, 4), 10);
    const ano = parseInt(dataNascimento.substring(4, 8), 10);

    const nascimento = new Date(ano, mes - 1, dia);
    const hoje = new Date();

    let idade = hoje.getFullYear() - nascimento.getFullYear();
    const mesAtual = hoje.getMonth() + 1;
    const diaAtual = hoje.getDate();

    if (mesAtual < mes || (mesAtual === mes && diaAtual < dia)) {
      idade--;
    }

    return idade;
  }

  const limiteMeses =
    idadeCliente == null || 35 + calcularIdade(idadeCliente) <= 80
      ? 420
      : 960 - calcularIdade(idadeCliente) * 12;

  const limiteMesesCGI =
    idadeCliente == null || 35 + calcularIdade(idadeCliente) <= 80
      ? 180
      : 960 - calcularIdade(idadeCliente) * 12;

  const handleChange = (event) => {
    setTipoImovel(event.target.value);
  };

  const handleChangeSituacaoImovel = (event) => {
    setSituacaoImovel(event.target.value);
  };

  const validadorPrazoPorMesesCgiIsErro = () => {
    const idade = calcularIdade(idadeCliente);
    if (idade <= 18 || idade >= 100) return false;

    const prazo = Number(prazoMesesCgi);
    if (isNaN(prazo)) return false;

    const limiteMin = 25;
    const limiteMax = 180;

    return (
      (prazo > 0 && prazo < limiteMin) ||
      prazo > limiteMax ||
      prazo > limiteMesesCGI
    );
  };

  const validadorPrazoPorMesesFinInter = () => {
    const idade = calcularIdade(idadeCliente);
    if (idade <= 18 || idade >= 100) return false;

    const prazo = Number(prazoMeses);
    if (isNaN(prazo)) return false;

    const limiteMin = 13;
    const limiteMax = 420;

    return (
      (prazo > 0 && prazo < limiteMin) ||
      prazo > limiteMax ||
      prazo > limiteMeses
    );
  };

  useEffect(() => {
    validadorPrazoPorMesesFinInter();
  }, [prazoMeses, limiteMeses]);

  useEffect(() => {
    validadorPrazoPorMesesCgiIsErro();
  }, [prazoMesesCgi, limiteMesesCGI]);

  return (
    <Container>
      <Row
        className="d-flex align-items-start flex-wrap"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        <Col xs={12} md={4} lg={3} xl={3} className="mb-2 ">
          <Form.Label className="label">
            Tipo de imóvel
            <Form.Select value={tipoImovel} onChange={handleChange}>
              <option value="Residencial">Residencial</option>
            </Form.Select>
          </Form.Label>
        </Col>

        <Col xs={12} md={4} lg={3} xl={3} className="mb-2">
          <Form.Label className="label">
            Situação do imóvel
            <Form.Select
              value={situacaoImovel}
              onChange={handleChangeSituacaoImovel}
            >
              <option value="Novo">Novo</option>
              <option value="Usado">Usado</option>
            </Form.Select>
          </Form.Label>
        </Col>
        {cgi == "CGI" ? (
          <Col xs={12} sm={7} md={6} lg={6} xl={5} className="mb-2">
            <Form.Label className="label">
              Valor do Imóvel
              <InputGroup>
                <NumericFormat
                  className="form-control"
                  value={valorImovelCgi}
                  onValueChange={(values) =>
                    setValorImovelCgi(values.value || "")
                  }
                  placeholder="R$ 0,00"
                  fixedDecimalScale={true}
                  decimalScale={2}
                  thousandSeparator="."
                  decimalSeparator=","
                  allowNegative={false}
                  customInput="input"
                  prefix="R$ "
                  maxLength={17}
                  isNumericString
                />
              </InputGroup>
              {((valorImovelCgi < 200000.0 && valorImovelCgi != 0) ||
                valorDoImovelCgiIsErro) && (
                  <p
                    className="text-danger m-0 p-0 mt-1"
                    style={{ fontSize: "12px" }}
                  >
                    Valor do Imovél inválido
                  </p>
                )}
            </Form.Label>
          </Col>
        ) : (
          <Col xs={12} sm={7} md={6} lg={6} xl={5} className="mb-2">
            {selectInter === "Multibancos" ? (
              <>
                <Form.Label className="label">
                  Valor do Imóvel
                  <InputGroup>
                    <NumericFormat
                      className="form-control"
                      value={valorDoImovel}
                      onValueChange={(values) =>
                        setValorDoImovel(values.value || "")
                      }
                      placeholder="R$ 0,00"
                      fixedDecimalScale={true}
                      decimalScale={2}
                      thousandSeparator="."
                      decimalSeparator=","
                      allowNegative={false}
                      customInput="input"
                      prefix="R$ "
                      maxLength={17}
                      isNumericString
                    />
                  </InputGroup>
                  {((valorDoImovel < 100000.0 && valorDoImovel != 0) ||
                    valorDoImovelIsErro) && (
                      <p
                        className="text-danger m-0 p-0 mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        Valor do Imovél inválido
                      </p>
                    )}
                </Form.Label>
              </>
            ) : (
              <>
                <Form.Label className="label">
                  Valor do Imóvel
                  <InputGroup>
                    <NumericFormat
                      className="form-control"
                      value={valorDoImovel}
                      onValueChange={(values) =>
                        setValorDoImovel(values.value || "")
                      }
                      placeholder="R$ 0,00"
                      fixedDecimalScale={true}
                      decimalScale={2}
                      thousandSeparator="."
                      decimalSeparator=","
                      allowNegative={false}
                      customInput="input"
                      prefix="R$ "
                      maxLength={17}
                      isNumericString
                    />
                  </InputGroup>
                  {((valorDoImovel < 200000.0 && valorDoImovel != 0) ||
                    valorDoImovelIsErro) && (
                      <p
                        className="text-danger m-0 p-0 mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        Valor do Imovél inválido
                      </p>
                    )}
                </Form.Label>
              </>
            )}
          </Col>
        )}
      </Row>

      <Row
        className="d-flex align-items-start flex-wrap"
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        {cgi != "CGI" ? (
          <Col xs={12} md={3} lg={3} xl={2} className="mb-2">
            <Form.Label className="label">
              Valor de FGTS
              <InputGroup className="">
                <NumericFormat
                  className="form-control"
                  placeholder="R$ 0,00"
                  thousandSeparator="."
                  decimalSeparator=","
                  decimalScale={2}
                  allowNegative={false}
                  maxLength={16}
                  fixedDecimalScale
                  prefix="R$ "
                  value={valorFGTS}
                  onValueChange={(values) => setValorFGTS(values.value || "")}
                  customInput={Form.Control}
                />
              </InputGroup>
              {((valorDeEntrada + valorFGTS < valorDoImovel * 0.2 &&
                valorDeEntrada > 0) ||
                valorEntradaIsErro) && (
                  <p
                    className="text-danger m-0 p-0 mt-1"
                    style={{ fontSize: "12px" }}
                  >
                    Valor de FGTS inválido
                  </p>
                )}
            </Form.Label>

          </Col>
        ) : null}

        {cgi != "CGI" ? (
          <Col xs={12} md={8} lg={9} xl={5} className="mb-2">
            <Form.Label className="label">
              <div className="d-flex align-items-center justify-content-start gap-1">
                Valor de entrada
                {selectInter === "Multibancos" ? (
                  <Link
                    id="t-2"
                    title="O valor mínimo de entrada corresponde a 20% do valor do financiamento na maioria dos bancos."
                  >
                    <InformationCircleIcon
                      strokeWidth={2}
                      style={{
                        width: "15px",
                        paddingBottom: "2px",
                        border: "10px",
                        color: "#555af8",
                      }}
                    />
                  </Link>
                ) : (
                  <Link
                    id="t-2"
                    title="O valor mínimo de entrada corresponde a 25% do valor do financiamento na maioria dos bancos."
                  >
                    <InformationCircleIcon
                      strokeWidth={2}
                      style={{
                        width: "15px",
                        paddingBottom: "2px",
                        border: "10px",
                        color: "#555af8",
                      }}
                    />
                  </Link>
                )}
              </div>
              {selectInter === "Multibancos" ? (
                <>
                  <InputGroup>
                    <NumericFormat
                      maxLength={17}
                      className="form-control"
                      placeholder="R$ 0,00"
                      thousandSeparator="."
                      decimalSeparator=","
                      allowNegative={false}
                      decimalScale={2}
                      fixedDecimalScale
                      prefix="R$ "
                      value={valorDeEntrada}
                      onValueChange={(values) =>
                        setValorDeEntrada(values.floatValue || "")
                      }
                      customInput={Form.Control}
                    />
                    <InputGroup.Text
                      style={{
                        color: "rgba(0, 0, 0, 0.40)",
                        background: "rgba(0, 0, 0, 0.03)",
                        fontSize: "14px",
                      }}
                    >
                      Mín. de {formatToReal(valorDoImovel * 0.2)}
                    </InputGroup.Text>
                  </InputGroup>
                  {((valorDeEntrada + valorFGTS < valorDoImovel * 0.2 &&
                    valorDeEntrada > 0) ||
                    valorEntradaIsErro) && (
                      <p
                        className="text-danger m-0 p-0 mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        Valor de entrada inválido
                      </p>
                    )}
                </>
              ) : (
                <>
                  <InputGroup>
                    <NumericFormat
                      maxLength={17}
                      className="form-control"
                      placeholder="R$ 0,00"
                      thousandSeparator="."
                      decimalSeparator=","
                      allowNegative={false}
                      decimalScale={2}
                      fixedDecimalScale
                      prefix="R$ "
                      value={valorDeEntrada}
                      onValueChange={(values) =>
                        setValorDeEntrada(values.floatValue || "")
                      }
                      customInput={Form.Control}
                    />
                    <InputGroup.Text
                      style={{
                        color: "rgba(0, 0, 0, 0.40)",
                        background: "rgba(0, 0, 0, 0.03)",
                        fontSize: "14px",
                      }}
                    >
                      Mín. de {formatToReal(valorDoImovel * 0.25)}
                    </InputGroup.Text>
                  </InputGroup>
                  {((valorDeEntrada + valorFGTS < valorDoImovel * 0.25 &&
                    valorDeEntrada > 0) ||
                    valorEntradaIsErro) && (
                      <p
                        className="text-danger m-0 p-0 mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        Valor de entrada inválido
                      </p>
                    )}
                </>
              )}
            </Form.Label>{" "}
          </Col>
        ) : null}
        {cgi == "CGI" ? (
          <Col xs={12} md={9} lg={10} xl={6} className="mb-2">
            <Form.Label className="label">
              <div className="d-flex align-items-center justify-content-start gap-1">
                Valor de empréstimo
                <Link
                  id="t-2"
                  title="Valor mínimo de R$ 70.000,00 e máximo 58% do valor do imóvel"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    style={{
                      width: "15px",
                      paddingBottom: "2px",
                      border: "10px",
                      color: "#555af8",
                    }}
                  />
                </Link>
              </div>
              <>
                <InputGroup>
                  <NumericFormat
                    maxLength={17}
                    className="form-control"
                    placeholder="R$ 0,00"
                    thousandSeparator="."
                    decimalSeparator=","
                    allowNegative={false}
                    decimalScale={2}
                    fixedDecimalScale
                    prefix="R$ "
                    value={valorEmprestimo}
                    onValueChange={(values) =>
                      setValorEmprestimo(values.floatValue ?? 0)
                    }
                    customInput={Form.Control}
                  />
                  <InputGroup.Text
                    style={{
                      color: "rgba(0, 0, 0, 0.40)",
                      background: "rgba(0, 0, 0, 0.03)",
                      fontSize: "14px",
                    }}
                  >
                    Máx. de {formatToReal(valorImovelCgi * 0.58)}
                  </InputGroup.Text>
                </InputGroup>
                {((valorEmprestimo > 0 && valorEmprestimo <= 70000) ||
                  valorEmprestimo > valorImovelCgi * 0.58 ||
                  valorEmprestimoIsErro) && (
                    <p
                      className="text-danger m-0 p-0 mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      Valor de empréstimo inválido
                    </p>
                  )}
              </>
            </Form.Label>
          </Col>
        ) : null}
        {cgi == "CGI" ? (
          <Col xs={12} sm={7} md={6} lg={6} xl={6} className="mb-2">
            <Form.Label className="label">
              <div className="d-flex align-items-center justify-content-start gap-1">
                Prazo por meses
                <Link
                  id="t-2"
                  title="A idade máxima permitida para a obtenção do financiamento é de até 80 anos."
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    style={{
                      width: "15px",
                      paddingBottom: "2px",
                      border: "10px",
                      color: "#555af8",
                    }}
                  />
                </Link>
              </div>
              <InputGroup>
                <NumericFormat
                  className="form-control"
                  style={{ maxWidth: "20%" }}
                  placeholder="Meses"
                  value={prazoMesesCgi}
                  onValueChange={(values) =>
                    setPrazoMesesCgi(values.value || "")
                  }
                  isAllowed={(values) => {
                    const { value } = values;
                    return value <= 999 && value >= 0;
                  }}
                  inputProps={{
                    maxLength: 3,
                    type: "tel",
                  }}
                  allowNegative={false}
                  decimalScale={0}
                  max={3}
                  customInput={Form.Control}
                />
                <InputGroup.Text
                  style={{
                    color: "rgba(0, 0, 0, 0.40)",
                    background: "rgba(0, 0, 0, 0.03)",
                    fontSize: "14px",
                  }}
                >
                  {idadeCliente == null || 35 + idadeCliente <= 80 ? (
                    <span className="">Mín. de 25 & Máx. de 180 meses</span>
                  ) : (
                    <span className="">Máx. de {limiteMesesCGI} meses</span>
                  )}
                </InputGroup.Text>
              </InputGroup>
            </Form.Label>
            {(validadorPrazoPorMesesCgiIsErro() ||
              prazoMesesCgiIsErro ||
              prazoMesesCgi > limiteMesesCGI) && (
                <p
                  className="text-danger m-0 p-0 mt-1"
                  style={{ fontSize: "12px" }}
                >
                  Prazos inválido
                </p>
              )}
            {prazoMeses != 0 && isNaN(calcularIdade(idadeCliente)) && (
              <p
                className="text-danger m-0 p-0 mt-1"
                style={{ fontSize: "12px" }}
              >
                Idade não preenchida
              </p>
            )}
          </Col>
        ) : (
          <Col xs={12} sm={7} md={6} lg={6} xl={5} className="mb-2">
            <Form.Label className="label">
              <div className="d-flex align-items-center justify-content-start gap-1">
                Prazo por meses
                <Link
                  id="t-2"
                  title="A idade máxima permitida para a obtenção do financiamento é de até 80 anos.  Mín é 12 e Máx é 420"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    style={{
                      width: "15px",
                      paddingBottom: "2px",
                      border: "10px",
                      color: "#555af8",
                    }}
                  />
                </Link>
              </div>
              <InputGroup>
                <NumericFormat
                  className="form-control"
                  style={{ maxWidth: "20%" }}
                  placeholder="0"
                  value={prazoMeses}
                  onValueChange={(values) => setPrazoMeses(values.value || "")}
                  isAllowed={(values) => {
                    const { value } = values;
                    return value <= 999 && value >= 0;
                  }}
                  inputProps={{
                    maxLength: 3,
                    type: "tel",
                  }}
                  allowNegative={false}
                  decimalScale={0}
                  max={3}
                  customInput={Form.Control}
                />
                <InputGroup.Text
                  style={{
                    color: "rgba(0, 0, 0, 0.40)",
                    background: "rgba(0, 0, 0, 0.03)",
                    fontSize: "14px",
                  }}
                >
                  {idadeCliente == null || 35 + idadeCliente <= 80 ? (
                    <span className="">Máx. de 420 meses</span>
                  ) : (
                    <span className="">Máx. de {limiteMeses} meses</span>
                  )}
                </InputGroup.Text>
              </InputGroup>
            </Form.Label>
            {(validadorPrazoPorMesesFinInter() ||
              prazoMesesIsErro ||
              prazoMeses > limiteMeses) && (
                <p
                  className="text-danger m-0 p-0 mt-1"
                  style={{ fontSize: "12px" }}
                >
                  Prazos inválido
                </p>
              )}
            {prazoMeses != 0 && isNaN(calcularIdade(idadeCliente)) && (
              <p
                className="text-danger m-0 p-0 mt-1"
                style={{ fontSize: "12px" }}
              >
                Idade não preenchida
              </p>
            )}
          </Col>
        )}
      </Row>

      <Row
        className="d-flex align-items-start flex-wrap p-0 "
        style={{ fontFamily: "Inter, sans-serif" }}
      >
        {cgi != "CGI" ? (
          <Col xs={12} md={8} lg={3} className="mb-2 me-0">
            <Form.Label className="label">
              Valor de financiamento
              <InputGroup className="financ-value">
                <NumericFormat
                  className="form-control"
                  placeholder="R$ 0,00"
                  thousandSeparator="."
                  decimalSeparator=","
                  isNumericString={true}
                  decimalScale={2}
                  fixedDecimalScale
                  prefix="R$"
                  allowNegative={false}
                  value={valorDoImovel - valorDeEntrada - valorFGTS}
                  readOnly
                  customInput={Form.Control}
                  style={{ backgroundColor: "rgba(0, 0, 0, 0.03)" }}
                />
              </InputGroup>
            </Form.Label>
          </Col>
        ) : null}

        <Col xs={12} md={8} lg={3} className=" ms-0 mb-2">
          <Form.Label className="label">
            Renda mensal total
            <InputGroup className="financ-value">
              <NumericFormat
                className="form-control"
                placeholder="R$ 0,00"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                prefix="R$ "
                value={rendaTotal}
                readOnly
                customInput={Form.Control}
                style={{ backgroundColor: "rgba(0, 0, 0, 0.03)" }}
              />
            </InputGroup>
          </Form.Label>
        </Col>
      </Row>
    </Container>
  );
};

export default FormProperty;
